<div *ngIf="isBusy" class="spinner-overlay">
  <div class="spinner-content">
    <img src="../assets/noun-loader-3784345-FFFFFF.png" class="spinner" alt="" />
    <p class="spinner-message" *ngIf="spinnerMessage">{{ spinnerMessage }}</p>
  </div>
</div>
<img
  class="app-watermark"
  src="assets/swinglab-logo.png"
  alt=""
  aria-hidden="true" />
<header class="header-bar">
  <div class="header-content">
    <div class="brand">
      <img
        class="app-logo"
        src="assets/swinglab-logo.png"
        alt="Swing Lab" />
      <h1 class="app-name">{{this.title}}</h1>
    </div>

    <div class="user-dropdown" (click)="toggleDropdown()" *ngIf="isAuthenticated">
      <span class="welcome-text">Welcome, {{firstName}}</span>
      <svg class="dropdown-arrow" [class.rotated]="isDropdownOpen" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
        <path d="M3 4.5L6 7.5L9 4.5"/>
      </svg>
      
      <div class="dropdown-menu" [class.show]="isDropdownOpen">
        <a href="#" class="dropdown-item" (click)="logout($event)">Log Out</a>
      </div>
    </div>
  </div>
</header>
<hr />
<div class="page-shell">
  <router-outlet />
</div>
<footer class="footer" *ngIf="isAuthenticated">
  <div class="footer-buttons">
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('sessions')"
      (click)="navigateTo('sessions')">
      Sessions
    </button>
    <button
      class="btn footer-btn" 
      [class.active]="isActiveRoute('admin') || isActiveRoute('settings')"
      (click)="navigateTo('admin')">
      Settings
    </button>
    <!--
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('swings')"
      (click)="navigateTo('swings')">
      Swings
    </button>
    <button 
      class="btn footer-btn" 
      [class.active]="isActiveRoute('setup')"
      (click)="navigateTo('setup')">
      Setup
    </button>
    -->
  </div>
</footer>
